import { render, staticRenderFns } from "./DispatchedAttach.vue?vue&type=template&id=51a44616&"
import script from "./DispatchedAttach.vue?vue&type=script&lang=js&"
export * from "./DispatchedAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports